<template>
    <!-- Modal -->
    <div class="modal" id="roomCheckoutModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">체크아웃</h4>
                    <button type="button" class="btn btn-m flat btn-close" data-dismiss="modal" aria-label="Close">
                        <i class="icon-close"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="text-center mt-40">
                        <b>해당 이용객을 체크아웃 하시겠습니까?</b>
                    </p>
                    <p class="text-center text-666 mt-15">{{selectedCheckoutBooking.roomGuest.visitor.visitorName}} / {{selectedCheckoutBooking.roomGuest.visitor.visitorCompany}}<br />
                        {{ getDateString(selectedCheckoutBooking.fromDate) }} ~ {{getDateString(selectedCheckoutBooking.toDate)}}
                    </p>
                    <hr style="width:auto; margin:20px -20px;background-color:#e2e2e2;">
                    <p class="text-light-blue">
                        <i class="icon-dot mr-5"></i>체크아웃은 IDC 퇴실과 별개로 관리됩니다.</p>
                    <div class="btn-wrap justify-content-center mt-20 mb-40">
                        <button class="btn btn-lg line-2" data-dismiss="modal" aria-label="Close">
                            <i class="icon-close mr-5"></i>취소</button>
                        <button class="btn btn-lg danger" data-dismiss="modal" aria-label="Close" @click="submit()">
                            <i class="icon-check mr-5"></i>체크아웃</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "roomCheckoutModal",
        props: ['selectedCheckoutBooking'],
        data() {
            return {
            }
        },
        watch: {
        },
        mounted(){

        },
        methods: {
            submit(){
                let param = {
                    bookingId: this.selectedCheckoutBooking.bookingId,
                };
                this.$http.post('/api/private/booking/room/checkout', param)
                    .then((result) => {
                        this.noti('완료', '체크아웃이 완료되었습니다.', 'success');
                        this.$emit('init');
                    }).catch((e) =>{
                    console.log(e);
                })
            },
            getDateString(timestamp){
                return moment.unix(timestamp/1000).format('YYYY년 MM월 DD일')
            },
        }
    }
</script>

<style scoped>

</style>